import { action, makeAutoObservable } from "mobx"
import { Coupon } from "../../../services/coupons/models";

export enum CouponsFormType {
    createCoupon = "createCoupon",
}

export enum FormDisplayType {
    popup = "popup",
    inline = "inline"
}

class CouponsFormsStore {
    forms: {
        [CouponsFormType.createCoupon]: {
            current?: Coupon,
            type: FormDisplayType,
            open: boolean
        },
    } = {
        [CouponsFormType.createCoupon]: {
            type: FormDisplayType.popup,
            open: false
        },
    };

    constructor() {
        makeAutoObservable(this);
        this.showPopupForm = this.showPopupForm.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    @action
    showPopupForm(type: CouponsFormType, current?: any) {
        this.forms[type].open = true;
        this.forms[type].current = current;
        this.forms[type].type = FormDisplayType.popup;
    }

    @action
    closeForm(type: CouponsFormType) {
        this.forms[type].open = false;
        this.forms[type].current = undefined;
    }

}

export default CouponsFormsStore
